export var sortSelectionsByOdd = function (s1, s2) {
    return s1.trueOdds - s2.trueOdds;
};
//# sourceMappingURL=sortSelectonsByOdd.js.map